import { SelectOption } from '@types';
import slugify from 'slugify';

/**
 * Normalizes a select option value or array of select options.
 *
 * @param selectOption - Either a string to create a select option or an array of existing select options.
 * @param toString - If true, returns the value of the first select option as a string. Defaults to false.
 * @returns If `toString` is true, returns a string value of the first select option.
 * Otherwise, returns an array of `SelectOption`.
 */

type SelectOptionParam = string | Array<SelectOption>;

// these are overloads to enfore the return type, otherwise we would have to do some weird looking "as any" stuff
export function normalizeSelect(selectOption: SelectOptionParam, toString: true): string;
export function normalizeSelect(selectOption: SelectOptionParam, toString?: false): Array<SelectOption>;
export function normalizeSelect(selectOption: SelectOptionParam, toString: boolean = false): SelectOptionParam {
  if (toString) {
    return normalizeSelect(selectOption, false)?.[0]?.value;
  }

  if (typeof selectOption === 'string') {
    return [generateSelectOption(selectOption)];
  }

  return selectOption;
}

/**
 * Generates a `SelectOption` from a given label.
 *
 * @param label - The label for the select option.
 * @returns A `SelectOption` object with a label and a slugified value.
 */
export const generateSelectOption = (label: string): SelectOption => {
  return { label: label, value: slugify(label, { lower: true, strict: true }) };
};
